import React, {Fragment, useMemo} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from 'react-redux';
import EnhancedModal from "../../../../../components/enhanced-modal";
import {GUTTER_MD, MODAL_WIDTH_LG, SPAN_HALF} from "../../../../../styles/constants";
import {
    deleteMapping,
    getDataFromCodelist,
    hideTranscodingSettings,
    setTranscodingSimpleValueSettings,
    submitSimpleValueTranscoding
} from "../actions";
import {Button, Col, Input, Row, Select, Tooltip} from "antd";
import Call from "../../../../../hocs/call";
import {capitalize} from "lodash";
import {getMappingSetDeleteStashRow} from "../../mapping-set-wizard/actions";

const mapStateToProps = state => ({
    appLanguage: state.app.language,
    showTranscodingSettings: state.scenes.mappingHandler.mappingSet.transcoding.showTranscodingSettings,
    columnCodelist: state.scenes.mappingHandler.mappingSet.transcoding.columnCodelist,
    data: state.scenes.mappingHandler.mappingSet.transcoding.data,
});

const mapDispatchToProps = dispatch => ({
    onHideTranscodingSettings: () => dispatch(hideTranscodingSettings()),
    onGetDataFromCodelist: (codelistTriplet) => dispatch(getDataFromCodelist(codelistTriplet)),
    setSimpleValue: (value) => dispatch(setTranscodingSimpleValueSettings(value)),
    submitSimpleValue: (value, mappingId) => dispatch(submitSimpleValueTranscoding(value, mappingId)),
    onDeleteStashRow: (row) => dispatch(getMappingSetDeleteStashRow(row)),
    onDeleteMapping: (mappingId) => dispatch(deleteMapping(mappingId))
});


const Simple01Transcoding = ({
                                 t,
                                 showTranscodingSettings,
                                 onHideTranscodingSettings,
                                 data,
                                 columnCodelist,
                                 onGetDataFromCodelist,
                                 setSimpleValue,
                                 appLanguage,
                                 submitSimpleValue,
                                 onDeleteStashRow,
                                 onDeleteMapping,
                             }) => {
    const hasCodelist = useMemo(() => data ? !!data.dsdCodelist : false, [data]);

    return (
        <Fragment>
            <Call cb={onGetDataFromCodelist}
                  cbParam={data ? data.dsdCodelist : null}
                  disabled={!data || !hasCodelist || !showTranscodingSettings}
            >
                <EnhancedModal
                    title={`Transcoding Settings for ${data ? data.dsdColumnName : "DSD col"}`}
                    visible={showTranscodingSettings}
                    width={MODAL_WIDTH_LG}
                    withDataLanguageSelector
                    onCancel={onHideTranscodingSettings}
                    footer={
                        <Fragment>
                            <Tooltip
                                title={t("scenes.mappingHandler.MappingSet.transcoding.tooltip.deleteTranscodingButton")}>
                                <Button
                                    icon="delete"
                                    onClick={() => {
                                        onDeleteStashRow(data);
                                        onDeleteMapping(data ? data.entityId : null);
                                        onHideTranscodingSettings();
                                    }}
                                >
                                    Delete Transcoding
                                </Button>
                            </Tooltip>
                            
                            <Button
                                onClick={() => onHideTranscodingSettings()}
                            >
                                {t('commons.buttons.close.title')}
                            </Button>
                            <Button
                                type="primary"
                                onClick={() => {
                                    submitSimpleValue(data ? data.constantValue : null, data? data.entityId : null);
                                    onHideTranscodingSettings();
                                }}
                            >
                                {t('commons.buttons.save.title')}
                            </Button>
                        </Fragment>
                    }
                >
                    <Row type="flex" gutter={GUTTER_MD}>
                        <Col span={SPAN_HALF}>
                            {t("scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.constantValueField")}:
                        </Col>
                        <Col span={SPAN_HALF}>
                            {hasCodelist && <Select
                                value={data ? data.constantValue : null}
                                style={{width: "100%"}}
                                onSelect={(value) => setSimpleValue(value)}
                                showSearch
                                filterOption={(inputValue, {props}) =>
                                    props.title.toLowerCase().includes(inputValue.toLowerCase())
                                }
                            >
                                {(columnCodelist || []).map(value =>
                                    <Select.Option
                                        key={value.Code}
                                        value={value.Code}
                                        title={`${value.Code} - ${value[`Name${capitalize(appLanguage)}`] ? value[`Name${capitalize(appLanguage)}`] : value["NameEn"]}`}
                                    >
                                        {value.Code} - {value[`Name${capitalize(appLanguage)}`] ? value[`Name${capitalize(appLanguage)}`] : value["NameEn"]}
                                    </Select.Option>
                                )}
                            </Select>}
                            {!hasCodelist &&
                                <Input value={data ? data.constantValue : null} style={{width: "100%"}} onChange={e => setSimpleValue(e.target.value)}/>}
                        </Col>
                    </Row>
                </EnhancedModal>
            </Call>
        </Fragment>
    )
};

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(Simple01Transcoding);